import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/anadeedigital-hp/htdocs/hp.anadeedigital.com/src/app/(pages)/tenders/wrapper.jsx");
